import React, { useState, useEffect, useRef } from 'react'
import style from './callvariable.css'
import { cloneDeep } from 'lodash';
import { Input, Button } from '@momentum-ui/react';
import CopyIcon from '../CopyIcon';
import ComponentsUtil from '../../utils/ComponentsUtil';
import PropTypes from "prop-types";
import Helpers from 'cd-ui-react/utils/helpers';
import { i18n } from '../../utils/GadgetUtils';
import useCallVariableProps from '../fin-imi/useCallVariableProps';

let focusObjects = {
	// id : ,
	// curPos: 
}
let callVariablePayLoad = {};
let eccVariableCombinedLength = 0;
function CallVariableLayout({unsavedChanges, setUnsavedChanges, ...props}) {

	 const [stateVariables, setStateVariables] = useState(
		{
			callvariablesArray: cloneDeep(props.mediaProperties.callVariables),
			disableSaveBtn: false,
			eccLength: 0
		}
	);
	const COMBINED_ECCVARIABLE_MAXLENGTH = 2000, SHOWWARNING_ECCVARIABLE_MAXLENGTH = 1950;
	const previousProps = useRef(props);
	const callVarEditStatus = useRef(props.callVariableEditStatus);
	const previoustaskId = useRef(props.taskId);
	const _useCallVariableProps = useCallVariableProps();

	
	useEffect(() => {
		setUnsavedChanges(stateVariables.disableSaveBtn);	
	}, [stateVariables.disableSaveBtn])

	useEffect(() => {
		if (JSON.stringify(props.mediaProperties.callVariables) === JSON.stringify(previousProps.current)) {
			if(callVarEditStatus.current === props.callVariableEditStatus){
					previousProps.current = props.mediaProperties.callVariables;
					callVarEditStatus.current = props.callVariableEditStatus;
					previoustaskId.current = props.taskId;			
					return;
				}
		}
		if (Object.keys(callVariablePayLoad).length === 0) {
			setStateVariables(prevState => ({ 
				...prevState,
				callvariablesArray: props.mediaProperties.callVariables,
			}));
		}
		else {
			// let updated = isCallVariablesUpdatedBySameAgent(props.mediaProperties.callVariables);
			if (props.callVariableEditStatus === 'SUCCESS') {
				callVariablePayLoad = {};
				setStateVariables(prevState => ({ 
					...prevState,
					callvariablesArray: props.mediaProperties.callVariables,
					disableSaveBtn: false
				}));
			} 
			else if(props.callVariableEditStatus === 'IN_PROGRESS'){
				callVariablePayLoad = {};
				eccVariableCombinedLength = 0;
				setStateVariables(prevState => ({ 
					...prevState,
					showEccMaxLengthExceeded: false, 
					disableSaveBtn: false
				}));
			}
			else if(props.callVariableEditStatus === 'NO_DATA'){
				eccVariableCombinedLength = 0;
				// callVariablePayLoad = {};
				setStateVariables(prevState => ({ 
					...prevState,
					showEccMaxLengthExceeded: false, 
					disableSaveBtn: true
				}));
			}
			else {
					callVariablePayLoad = {};
					eccVariableCombinedLength = 0;	
					setStateVariables(prevState => ({ 
						...prevState,
						callvariablesArray: props.mediaProperties.callVariables,
						showEccMaxLengthExceeded: false, 
						disableSaveBtn: false
					}));
			}

		}
		previousProps.current = props.mediaProperties.callVariables;
		callVarEditStatus.current = props.callVariableEditStatus;
	},[props])

	useEffect(()=> {
		callVariablePayLoad = {};
		eccVariableCombinedLength = 0;
		let updatedCallVariablesArray = cloneDeep(stateVariables.callvariablesArray);

		setStateVariables(prevState => ({ 
			...prevState,
			callvariablesArray: props.mediaProperties.callVariables,
			showEccMaxLengthExceeded: false, 
			disableSaveBtn: false
		}));
	}, [props.callvariablesArray])

	
	useEffect(() => {
		if(focusObjects.id && focusObjects.id != ''){
			ComponentsUtil.setFocusByElementID(focusObjects.id);
			const element = document.getElementById(focusObjects.id);
			if (element) {
				let curPos = focusObjects.curPos;
				if (element.setSelectionRange !== 'undefined') {
					element.setSelectionRange(curPos, curPos);
				}
			}
		}
		
	},[{...focusObjects}])

	/**
	 * The call variables are not editable in case the call failied due to Busy
	 */
	const checkFailedBusyState = () => {
		if (props.callState === 'FAILED' && props.callError && props.callError.appearanceMsg &&
			props.callError.appearanceMsg.msg === i18n.getMsg('gadget.callcontrol.callstate.busy')) {
			return true;
		}
		return false;
	};

	/**
	 * check the uiEditable field is true for any of the callvariables which is not hidden
	 */
	 const checkUiEditableFieldValue = (callVariablesColumn) => {
		if (!callVariablesColumn) {
			return;
		}
		for (let i = 0; i < callVariablesColumn.length; i++) {
			let entry = callVariablesColumn[i];
			if (entry.uiEditable === 'true' && entry.hide !== true) {
				return true;
			}
		}
		return false;
	};

	/**
	 * The Edit and Revert buttons are visible when atleast one call variable is editable
	 */
	const checkEditable = (callVariables) => {
		let needEditArea = false;

		if (checkFailedBusyState()) {
			return needEditArea;
		}
		needEditArea = checkUiEditableFieldValue(callVariables[0]);

		if (!needEditArea && callVariables[1] !== null) {
			needEditArea = checkUiEditableFieldValue(callVariables[1]);
		}
		return needEditArea;
	};

	/**
	 * return 0 in case the requested call variable is not found in the new callvariable list
	 * return 1 in case the requested call variable values are found in the new callvariable list.
	 * return 2 in case the new callvariable list is not updated with the requested one.
	 */
	 const compareCallVariables = (newCallVariablesColumn) => {
		for (let i = 0; i < newCallVariablesColumn.length; i++) {
			let newEntry = newCallVariablesColumn[i];
			let encodedMediaProperty = ComponentsUtil.encodeSpecialChars(newEntry.mediaProperty);
			if (newEntry.hide !== true && callVariablePayLoad.hasOwnProperty(encodedMediaProperty)) {
				if (ComponentsUtil.encodeSpecialChars(newEntry.value).replace(/\s+/g, ' ') === callVariablePayLoad[encodedMediaProperty].replace(/\s+/g, ' ')) {
					// in case the call variable updated to the requested value then
					// the update happen to all the requested one
					return 1;
				} else {
					return 2;
				}
			}
		}
		return 0;
	};

	/**
	 * check whether the callvariables are updated
	 * @param {Array} newCallVariables
	 */
	const isCallVariablesUpdatedBySameAgent = (newCallVariables) => {
		let changeFlag = 0;
		changeFlag = compareCallVariables(newCallVariables[0]);

		if (changeFlag === 0 && newCallVariables[1] != null) {
			changeFlag = compareCallVariables(newCallVariables[1]);
		}
		return (changeFlag === 1);
	};

	let saveClickHandler = action => event => {
		event.stopPropagation();
		setStateVariables(prevState => ({ 
			...prevState,
			showEccMaxLengthExceeded: false,
			disableSaveBtn: false, 
			eccLength: 0
		}));
		props.myParticipant.actions['UPDATE_CALL_DATA'].actionListener(callVariablePayLoad);
		focusObjects.id='';
		focusObjects.curPos='';
	};


	let revertHandler = () => {
		callVariablePayLoad = {};
		eccVariableCombinedLength = 0;
		if (props.callVariableEditStatus === 'ERROR') {
			console.log('Error in revertHandler');
		}
		setStateVariables(prevState => ({ 
			...prevState,
			callvariablesArray: props.mediaProperties.callVariables,
			showEccMaxLengthExceeded: false, 
			eccLength: 0,
			disableSaveBtn: false
		}));
		focusObjects.id='';
		focusObjects.curPos='';
	};

	let revertClickHandler = action => event => {
		event.stopPropagation();
		revertHandler();
	};
	
	const returnTruncatedValue = (updatedValue, maxLengthOfColumn) => {
		let existingTempColValue = '', updatedValueLength = 0;
		for (let i = 0; i < updatedValue.length; i++) {
			let char = updatedValue.charCodeAt(i);
			updatedValueLength += ComponentsUtil.getLengthOfChar(char);
			if (updatedValueLength <= maxLengthOfColumn) {
				existingTempColValue = existingTempColValue + updatedValue[i];
			}
		}
		return existingTempColValue;
	};
		

	const inputHandler = (event, id) => {

		let columnIndex = event.target.dataset.colindex;
		let updatedValue = event.target.value;
		let columnName = event.target.dataset.name;
		
		let index = stateVariables.callvariablesArray[columnIndex].findIndex(entry => entry.name === columnName);

		let existingColumnValue = props.mediaProperties.callVariables[columnIndex].find(entry => entry.name === columnName).value;

		let mediaPropertyName = props.mediaProperties.callVariables[columnIndex].find(entry => entry.name === columnName).mediaProperty;
		let maxLengthOfColumn = props.mediaProperties.callVariables[columnIndex].find(entry => entry.name === columnName).maxLength;
		let updatedValueByteLength = ComponentsUtil.getByteLen(updatedValue);

		if (updatedValueByteLength > maxLengthOfColumn) {
			updatedValue = stateVariables.callvariablesArray[columnIndex][index].value; // if reached maximum limit, then do not allow agent to type anymore chars
			updatedValueByteLength = ComponentsUtil.getByteLen(updatedValue);
		}

		if (mediaPropertyName.startsWith('user.')) {
			if (callVariablePayLoad[mediaPropertyName]) {
				let existingByteLength = ComponentsUtil.getByteLen(callVariablePayLoad[mediaPropertyName]);
				eccVariableCombinedLength -= existingByteLength;
			}
			if (updatedValue !== existingColumnValue) {
				let tempLength = eccVariableCombinedLength + updatedValueByteLength;
				if (tempLength > COMBINED_ECCVARIABLE_MAXLENGTH) {
					updatedValue = returnTruncatedValue(updatedValue, COMBINED_ECCVARIABLE_MAXLENGTH - eccVariableCombinedLength);
					eccVariableCombinedLength += ComponentsUtil.getByteLen(updatedValue);
					setStateVariables(prevState => ({ 
						...prevState,
						showEccMaxLengthExceeded: true, 
						eccLength: 0,
					}));
				} else {
					eccVariableCombinedLength = tempLength;
					if (eccVariableCombinedLength >= SHOWWARNING_ECCVARIABLE_MAXLENGTH && eccVariableCombinedLength <= COMBINED_ECCVARIABLE_MAXLENGTH) {
						let eccLength = COMBINED_ECCVARIABLE_MAXLENGTH - tempLength;
						setStateVariables(prevState => ({ 
							...prevState,
							showEccMaxLengthExceeded: true, 
							eccLength: eccLength,
						}));
					} else {
						setStateVariables(prevState => ({ 
							...prevState,
							showEccMaxLengthExceeded: false, 
						}));
					}
				}
			} else {
				setStateVariables(prevState => ({ 
					...prevState,
					showEccMaxLengthExceeded: false, 
				}));
			}
		}

		let updatedCallVariablesArray = cloneDeep(stateVariables.callvariablesArray);

		updatedCallVariablesArray[columnIndex][index].value = updatedValue;
		updatedValue = updatedValue.trim();
		if (updatedValue !== existingColumnValue) {
			callVariablePayLoad[ComponentsUtil.encodeSpecialChars(mediaPropertyName)] = ComponentsUtil.encodeSpecialChars(updatedValue);
			setStateVariables(prevState => ({ 
				...prevState,
				callvariablesArray: updatedCallVariablesArray,
				disableSaveBtn: true
			}));
		} else {
			if (callVariablePayLoad[mediaPropertyName]) delete callVariablePayLoad[mediaPropertyName];

			if (Object.keys(callVariablePayLoad).length === 0) {
				setStateVariables(prevState => ({ 
					...prevState,
					callvariablesArray: updatedCallVariablesArray,
					disableSaveBtn: false
				}));
			} else {
				setStateVariables(prevState => ({ 
					...prevState,
					callvariablesArray: updatedCallVariablesArray,
					disableSaveBtn: true
				}));

			}
		}
		focusObjects.id=id;
		if (ComponentsUtil.getByteLen(event.target.value) > maxLengthOfColumn) {
			// place cursor at end as it aligns with voice
			const cvInputElement = document.getElementById(id);
			focusObjects.curPos = cvInputElement.value.length;
		} else {
			focusObjects.curPos=event.target.selectionStart;
		}
	}	


	let values = [];

	const componetId = Helpers.getComponentId('CVLayoutComponent');

	let callVariables = stateVariables.callvariablesArray;

	let returnEmpty = function () {
		return (<div className="hidden" />);
	};

	let filterToShow = function (callVariables) {
		return callVariables.filter((item) => !item.hide);
	};

	if (!props.show) {
		return returnEmpty();
	}

	let columns = [];

	if (callVariables[0] != null && callVariables[0].length > 0) {
		columns.push(filterToShow(callVariables[0]));
	}
	if (callVariables[1] != null && callVariables[1].length > 0) {
		columns.push(filterToShow(callVariables[1]));
	}
	if (columns.length === 0) {
		return returnEmpty();
	}

	/**
	 * This method will form the call variable row based on the key and value provided.
	 * @param {string} name Name of the call variable key
	 * @param {string} value call variable value
	 * @param {number} col Number of column this layout has
	 */

	 let renderColumn = (name, value, mediaProperty, uiEditable, col = 1, colIndex) => {

		return (
			<div key={name + componetId} className={`${style.callVariable}`}>  
				<div className={ `${style.callVariableName}`} id={`${mediaProperty.replace('.', '')}-label`}>
					{name}
				</div>

				{uiEditable === 'true' ? 
					<div className={style.callVariableValue}>
						<div className={style.inputDiv}>
							<Input id={`${mediaProperty.replace('.', '')}-imi`} data-name={name} data-colindex={colIndex}
							inputClassName={`${style.input}`}
							style={{'height':'36px', 'paddingTop': '6px'}}
							key='input' aria-label={name} tabIndex="0"
							multiline
							onChange={(event) => {inputHandler(event, `${mediaProperty.replace('.', '')}-imi`)}}
							onClick={(event) => {ComponentsUtil.cursorPosition(`${mediaProperty.replace('.', '')}-imi`)}}
							value={value} />
						
						<div className={style.copyIconDiv} id={`${mediaProperty.replace('.', '')}copy`}>
							<CopyIcon {...{value}}/>
						</div>
						</div>
					
					</div>
				: 
					<div id={mediaProperty.replace('.', '')} className={`${style.callVariableValueTP}`} type="text" tabIndex={value ? "0" : "-1"} aria-label={name}
						value={value}>{value}
					</div>
			}
				
			</div>
		);
	};


 
  values = columns.map((columnKey, colIndex) =>
			<div key={'call-variable-key_' + colIndex} className={`${style.callVariableColumn}`} >
				{
					Object.keys(columns[colIndex]).map((cvKey) =>
						renderColumn(columns[colIndex][cvKey].name, columns[colIndex][cvKey].value, columns[colIndex][cvKey].mediaProperty,
							false ? false : columns[colIndex][cvKey].uiEditable, columns.length, colIndex)
					)
				}
			</div>
		);

		

	var eccWarningMessage = i18n.getString('gadget.callcontrol.editcallvariable.eccVariables.maxLengthReached', stateVariables.eccLength);
	var infoMessage = i18n.getMsg('gadget.callcontrol.callvariable.info');
	var successMessage = i18n.getMsg('gadget.callcontrol.nonvoice.callvariable.success');
	

  return (
    <div className={style.callVariableAreaContainer}>
      <div id="call-variables-area" className={`${style.callVariablesArea}`}>
				{values}
		</div>
		{checkEditable(props.mediaProperties.callVariables) && <div className={'error-text-area'}>
					{props.callVariableEditStatus === 'ERROR' && <span className={`${style.cvlayoutEditStatus}`}>
						<md-icon name="icon-error_12" color="#A12512" />
						<div className={style.errorMessage}>
							{props.callVariableError}
							</div>
					</span>}
					{props.callVariableEditStatus === 'INFO' && <span className={`${style.cvlayoutEditStatus}`}>
					<md-icon name='icon-warning_12' color='#7D4705'/>
					<div className={style.infoMessage}> {infoMessage} </div>
					</span>}
					{props.callVariableEditStatus === 'SUCCESS' && <span className={`${style.cvlayoutEditStatus}`}>
						<md-icon name='icon-check-circle_12' color='#03612C' />
						<div className={style.successMessage}>{successMessage}</div>
					</span>}
					{stateVariables.showEccMaxLengthExceeded && <span className={`${style.cvlayoutEditStatus}`}>
						<md-icon name='icon-warning_12' color='#7D4705'/>
						<div className={style.eccMaxLengthWarning}> {eccWarningMessage} </div>
					</span>}
					{(!props.callVariableEditStatus || props.callVariableEditStatus === 'NO_DATA') && <span />}
					<div id='btnGroup-cv-imi' className={style.btnGroup}>
						{!props.disableButtons && 	
							<Button id = 'revertBtn-cv-imi' className={style.revertBtn}
				 				aria-label={'Revert'} tabIndex="0"
								onClick={revertClickHandler('UPDATE_CALL_DATA')}
								disabled={props.disableButtons || !stateVariables.disableSaveBtn}
								>
									{i18n.getMsg('gadget.imi.revertbtn')}
							</Button>
						}
						{!props.disableButtons && 
						
						<Button id='saveBtn-cv-imi' className={style.saveBtn}
								onClick={saveClickHandler('UPDATE_CALL_DATA')} tabIndex="0"
								disabled={props.disableButtons || !stateVariables.disableSaveBtn}
								aria-label={i18n.getMsg('gadget.imi.savebtn')} 
								color='blue'>
							{
							 props.callVariableEditStatus === 'IN_PROGRESS' ?
							 <md-spinner size={16}></md-spinner>:
							 i18n.getMsg('gadget.imi.savebtn')
							}
							  </Button> 
						}
					</div> 
		</div> }

    </div>

  )
}

CallVariableLayout.propTypes = {
	show: PropTypes.bool,
	mediaProperties: PropTypes.shape({
		callVariables: PropTypes.object
	}),
	styleOveride: PropTypes.object,
	callVariableEditStatus: PropTypes.string,
	/* Unique call id */
	taskId: PropTypes.string,
	myParticipant: PropTypes.object,
	callVariableError: PropTypes.string,
	callError: PropTypes.object,
	callState: PropTypes.string,
	disableButtons: PropTypes.bool
};


export default CallVariableLayout